import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
  colors,
} from "@mui/material";
import React from "react";
import { json, useNavigate } from "react-router-dom";
import { ThemeColors } from "../../../../constant/ThemeColors";
import { ReadableDate } from "../../../../utils/ReadableDateTime";
import { jobStatus } from "../../../../constant/GlobalVariable";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export function ClientProfileJobCard({ id, url = "/jobs/detail/", job }) {
  const navigate = useNavigate();

  return (
    <>
      <Box
        onClick={() => {
          navigate(url + job?.job_id);
        }}
        px={1}
        borderRadius={1}
        boxShadow={"0 0 3px -3px"}
        width={{ lg: "32%", md: "48%", xs: "100%" }}
        sx={{
          ":hover": {
            cursor: "pointer",
            boxShadow: ThemeColors.hoverBoxShadow,
          },
          border: 0.5,
          borderBottom: 4,
          borderColor: ThemeColors.borderColor,
        }}
      >
        <List dense>
          <ListItem sx={{ justifyContent: "space-between" }}>
          <ListItemText
              primaryTypographyProps={{
                fontSize: 18,
                fontWeight: "600",
                textTransform:'capitalize'
              }}
              primary={
                job?.name 
              }
            />

            <ListItemText
              primaryTypographyProps={{
                fontSize: 18,
                fontWeight: "700",
              }}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
              primary={job.job_id}
            />
          </ListItem>
          <ListItem dense>
         

            <ListItemText
              primaryTypographyProps={{
                fontSize: 16,
                fontWeight: "500",
                // color: "GrayText",
              }}
              primary={
                job?.client_details?.first_name +
                " " +
                job?.client_details?.last_name
              }
              secondaryTypographyProps={{
                fontSize: 14,
                // color: "GrayText",
              }}
              secondary={`${job?.client_details?.street}, ${job?.client_details?.city}, ${job?.client_details?.state}, ${job?.client_details?.country}`}
            />
          </ListItem>
          
        </List>
        <Divider />
        <Typography
          display={"flex"}
          justifyContent={"space-between"}
          columnGap={1}
          px={2}
          py={1}
        >
          <Typography
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 0.5,
              py: 0.3,
            }}
          >
            <Typography component={"span"}>
              <AccessTimeIcon
                sx={{ display: "flex" }}
                htmlColor={ThemeColors.iconColor}
              />
            </Typography>
            <Typography component={"span"} noWrap sx={{ display:'flex', alignItems:'center',gap:0.5, fontWeight: "400" }}>
              <Typography
                component={"span"}
                noWrap
                sx={{
                  fontSize: 15,
                  fontWeight: "300",
                  // color: "GrayText"
                }}
              >
                {job?.job_status == jobStatus?.UPCOMING ? (
                  "Upcoming: "
                ) : (
                  <>
                    {job?.job_status == jobStatus?.INPROGRESS ? (
                      "IN Progress"
                    ) : (
                      <>
                        {job?.job_status == jobStatus?.COMPLETE ? (
                          "Completed:"
                        ) : (
                          <>
                            <Typography>
                              <Button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/jobs/update/" + job.job_id);
                                }}
                                sx={{
                                  pr: 0.5,
                                }}
                                m={0}
                                variant="outlined"
                              >
                                Schedule
                                <KeyboardArrowRightIcon p={0} />
                              </Button>
                            </Typography>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Typography>
              <Typography component={"span"} noWrap>
                {job?.job_status === jobStatus?.UPCOMING ? (
                  <>{ReadableDate(job?.schedule_date)}</>
                ) : (
                  <>
                    {job?.job_status === jobStatus?.INPROGRESS ? (
                      <></>
                    ) : (
                      <>
                        {job?.job_status === jobStatus?.COMPLETE ? (
                          <>{ReadableDate(job?.end_time)}</>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </>
                )}

                {job?.end_time ? <>{ReadableDate(job?.end_time)}</> : ""}
              </Typography>
            </Typography>
          </Typography>
        </Typography>
      </Box>
    </>
  );
}
